export const API_URL = process.env.REACT_APP_BOHDISYS_API_URL;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const STRIPE_PUBLIC_KEY_STAND = process.env.REACT_APP_STRIPE_PUBLIC_KEY_STAND;